import { CategoryChartParamFetchFn } from "../categoryChart";

export const nofetch: CategoryChartParamFetchFn = async ({ categoryChart, locationAdminIds, kpis = [], ...rest }) => {
    return {
        ...rest,
        categoryChart,
        locationAdminIds,
        kpis,
        latestYear: undefined
    };
};
